export default "__VITE_ASSET__86fd0cdd__"